import pagenotfound from './pagenotfoundfinal.png'

export default function PageNotFound(){
  return <div className='pagenotfound'>
    <h1>PAGE NOT FOUND</h1>
    <img src={pagenotfound}></img>
  </div>
}